import { DataFormField } from "types/models/input-field-type";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import { listBacSy1 } from "data/list";
import { listOptionMat } from "pages/Examination/components/InforDetail/DetailTabInfo/components/ConcludePrecription/ConcludeIcd/ConcludeIcd.config";

const {
  DATE,
  NUMBER,
  INPUT,
  SELECT,
  TEXT_AREA,
  AUTO_COMPLETE,
  DATE_PRE,
  DATE_DAY_INPUT,
  COMBO_BOX,
} = FIELD_TYPE;

const cssProps = {
  labelCol: { xs: 6, sm: 6, md: 6, lg: 6, xl: 9 },
  wrapperCol: { xs: 18, sm: 18, md: 18, lg: 18, xl: 15 },
  css: { xs: 24, sm: 24, md: 8, lg: 8, xl: 8 },
};

const cssProps2 = {
  labelCol: { xs: 2, sm: 2, md: 2, lg: 2, xl: 3 },
  wrapperCol: { xs: 22, sm: 22, md: 22, lg: 22, xl: 21 },
  css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
};
const cssProps3 = {
  labelCol: { xs: 4, sm: 4, md: 4, lg: 4, xl: 6 },
  wrapperCol: { xs: 20, sm: 20, md: 20, lg: 20, xl: 18 },
  css: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
};

export const phuongPhapVoCamOptions = [
  { value: "1", label: "Gây mê" },
  { value: "7", label: "Nhỏ tê tại chỗ" },
  { value: "2", label: "Tê cạnh nhãn cầu" },
  { value: "3", label: "Tê hậu nhãn cầu" },
  { value: "4", label: "Tê subtenon" },
  { value: "5", label: "Tê dưới da" },
  { value: "6", label: "Tiêm tê tại chỗ" },
  { value: "8", label: "Gây tê tại chỗ" },
];

const dataFieldsMap = (icdList, form, isView, dmBuong, dmGiuong) => {
  let icdOptions = icdList.map((it) => ({ value: it.maIcd, key: it.id }));
  let tenIcdOptions = icdList.map((it) => ({ value: it.tenIcd, key: it.id }));
  const onIdBVVSelect = (value, option) => {
    let tmp = icdList.find((it) => it.id === option.key)?.tenIcd;
    form.setFieldValue("benhVaoVien", tmp);
  };
  const onBVVSelect = (value, option) => {
    let tmp = icdList.find((it) => it.id === option.key)?.maIcd;
    form.setFieldValue("idBenhVaoVien", tmp);
  };
  const onIdBHCSelect = (value, option) => {
    let tmp = icdList.find((it) => it.id === option.key)?.tenIcd;
    form.setFieldValue("benhHoiChan", tmp);
  };
  const onBHCSelect = (value, option) => {
    let tmp = icdList.find((it) => it.id === option.key)?.maIcd;
    form.setFieldValue("idBenhHoiChan", tmp);
  };

  return [
    {
      name: "hoVaTen",
      type: INPUT,
      label: "Họ tên BN",
      disable: true,
      ...cssProps,
    },
    {
      name: "tuoi",
      type: INPUT,
      disable: true,
      label: "Tuổi",
      ...cssProps,
    },
    {
      name: "gioiTinh",
      type: SELECT,
      label: "Giới tính",
      disable: true,
      options: gioiTinhOptions.filter((it) => it.value !== null),
      ...cssProps,
    },
    {
      name: "diaChi",
      type: INPUT,
      label: "Địa chỉ",
      disable: true,
      ...cssProps2,
    },
    {
      name: "khoaDieuTri",
      type: INPUT,
      label: "Khoa mắt TH",
      disable: true,
      ...cssProps,
    },

    {
      name: "buong",
      type: SELECT,
      label: "Buồng",
      disable: true,
      ...cssProps,
      options: dmBuong.map((it) => ({ value: it.id, label: it.tenPhong })),
    },
    {
      name: "giuong",
      type: SELECT,
      label: "Giường",
      disable: true,
      ...cssProps,
      options: dmGiuong.map((it) => ({ value: it.id, label: it.soGiuong })),
    },
    {
      name: "thoiGianDieuTriTu",
      type: DATE,
      label: "Thời gian điều trị từ",
      disable: isView,
      ...cssProps,
      optionsTime: { format: FORMAT_TIME.dayFull, showTime: false },
      disableDate: false,
      changeOnBlur: true,
    },
    {
      name: "thoiGianDieuTriDen",
      type: DATE,
      label: "Thời gian điều trị đến",
      ...cssProps,
      optionsTime: { format: FORMAT_TIME.dayFull, showTime: false },
      disable: isView,
      disableDate: false,
      changeOnBlur: true,
    },
    {
      name: "thoiGianHoiChan",
      type: DATE,
      label: "Thời gian hội chẩn",
      ...cssProps,
      optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
      disable: isView,
      changeOnBlur: true,
    },
    {
      name: "thanhPhanThamGia",
      type: INPUT,
      label: "Thành phần tham gia",
      ...cssProps2,
      disable: isView,
      // options: listBacSy1,
    },
    {
      name: "chuToaHoiChan",
      type: COMBO_BOX,
      label: "Chủ toạ hội chẩn",
      ...cssProps2,
      disable: isView,
      options: listBacSy1,
    },
    {
      name: "thuKyHoiChan",
      type: COMBO_BOX,
      label: "Thư ký hội chẩn",
      ...cssProps2,
      disable: isView,
      options: listBacSy1,
    },
    {
      name: "idBenhVaoVien",
      type: AUTO_COMPLETE,
      label: "Bệnh vào viện",
      ...cssProps3,
      options: icdOptions,
      onSelect: onIdBVVSelect,
      disable: isView,
      filterOption: (inputValue, option) =>
        option!.value
          ?.toString()
          .toUpperCase()
          .indexOf(inputValue.toUpperCase()) !== -1,
    },
    {
      name: "benhVaoVien",
      type: AUTO_COMPLETE,
      wrapperCol: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      css: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
      options: tenIcdOptions,
      onSelect: onBVVSelect,
      disable: isView,
      filterOption: (inputValue, option) =>
        option!.value
          ?.toString()
          .toUpperCase()
          .indexOf(inputValue.toUpperCase()) !== -1,
    },
    {
      name: "idBenhHoiChan",
      type: AUTO_COMPLETE,
      label: "Bệnh hội chẩn",
      ...cssProps3,

      options: icdOptions,
      onSelect: onIdBHCSelect,
      disable: isView,
      filterOption: (inputValue, option) =>
        option!.value
          ?.toString()
          .toUpperCase()
          .indexOf(inputValue.toUpperCase()) !== -1,
    },
    {
      name: "benhHoiChan",
      type: AUTO_COMPLETE,
      wrapperCol: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      css: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
      options: tenIcdOptions,
      onSelect: onBHCSelect,
      disable: isView,
      filterOption: (inputValue, option) =>
        option!.value
          ?.toString()
          .toUpperCase()
          .indexOf(inputValue.toUpperCase()) !== -1,
    },
    {
      name: "quaTrinhDienTienBenh",
      type: TEXT_AREA,
      label: "Quá trình diễn biến bệnh",
      ...cssProps2,
      disable: isView,
    },
    {
      name: "ketLuan",
      type: TEXT_AREA,
      label: "Kết luận sau khi khám lại và HC",
      ...cssProps2,
      disable: isView,
    },
    // {
    //   name: "huongDieuTri",
    //   type: TEXT_AREA,
    //   label: "Hướng điều trị tiếp hội chẩn",
    //   ...cssProps2,
    //   disable: isView,
    // },
  ];
};

const treatDirection = (form, listStaff, dmPPPT, isView) => {
  return [
    {
      name: "mat",
      type: COMBO_BOX,
      label: "Mắt",
      ...cssProps3,
      disable: isView,
      // disabled: isDisabled,
      options: listOptionMat,
    },
    {
      name: "phuongPhapPhauThuat",
      type: COMBO_BOX,
      label: "Phương pháp phẫu thuật",
      ...cssProps3,
      disable: isView,
      // disabled: isDisabled,
      options: dmPPPT?.map((it) => ({ label: it.tenDichVu, value: it.id })),
    },

    {
      name: "phuongPhapVoCam",
      type: COMBO_BOX,
      label: "Phương pháp vô cảm",
      ...cssProps2,
      disable: isView,
      options: phuongPhapVoCamOptions,
      // disabled: isDisabled,
    },
    {
      name: "phauThuatVien",
      type: COMBO_BOX,
      label: "Phẫu thuật viên",
      ...cssProps2,
      disable: isView,
      options: listStaff?.list?.map((it) => ({
        value: it.name,
        label: it.name,
      })),
      // disabled: isDisabled,
    },
    {
      name: "ngayPhauThuat",
      type: DATE_DAY_INPUT,
      label: "Ngày phẫu thuật",
      ...cssProps2,
      disable: isView,
      disableDate: false,
      // disabled: isDisabled,
      changeOnBlur: true,
    },
  ];
};

export { dataFieldsMap, treatDirection };
